<div class="row gap-3">
  <div class="col custom-fields">
    <div class="custom-fields-container">
      <div id="data-grid">
        <dx-data-grid
          id="gridContainer"
          [dataSource]="fields"
          [showColumnHeaders]="true"
          [columnAutoWidth]="true"
          [showBorders]="false"
          [showColumnLines]="false"
          [showRowLines]="true"
          [allowColumnResizing]="true"
          (onRowPrepared)="onRowPrepared($event)"
        >
          <dxo-data-grid-row-dragging
            [allowReordering]="true"
            [onReorder]="onReorder"
            [showDragIcons]="true"
          ></dxo-data-grid-row-dragging>

          <dxi-column
            [caption]="'COMMON.SHOW' | translate"
            dataField="visible"
            [allowSorting]="false"
            cellTemplate="showTemplate"
            alignment="center"
          ></dxi-column>

          <div *dxTemplate="let data of 'showTemplate'">
            <dx-check-box
              [disabled]="data.data.isLocked"
              [(value)]="data.data.visible"
              (onValueChanged)="onVisibleChange(data.data)"
              [elementAttr]="{ class: 'required-checkbox' }">
            </dx-check-box>
          </div>

          <dxi-column
            [caption]="'COMMON.FIELD' | translate"
            dataField="key"
            [allowEditing]="false"
            [allowSorting]="false"
            cellTemplate="fieldTemplate"
          ></dxi-column>

          <div *dxTemplate="let cell of 'fieldTemplate'">
            <div 
              class="grid-field-cell"
              [ngClass]="{ 'width-175': cell.data.key === emailKey }"
            >
              <span class="field-label-text">
                {{ cell.text }}
              </span>
              <span *ngIf="cell.data.isLocked" class="always-on-badge">
                {{ 'GUEST-FORM-FIELDS.ALWAYS-ON' | translate }}
              </span>
            </div>
          </div>

          <dxi-column
            [caption]="'COMMON.LABEL' | translate"
            dataField="label"
            [allowEditing]="false"
            [allowSorting]="false"
            cellTemplate="labelTemplate">
          </dxi-column>

          <div *dxTemplate="let data of 'labelTemplate'">
            {{ getLabelKey(data.data.key) | translate }}
          </div>

          <dxi-column
            [caption]="'COMMON.REQUIRED' | translate"
            dataField="required"
            alignment="center"
            cellTemplate="requiredTemplate"
            [allowSorting]="false"
          ></dxi-column>

          <div *dxTemplate="let data of 'requiredTemplate'">
            <mat-slide-toggle
              [(ngModel)]="data.data.required"
              [disabled]="!data.data.visible || data.data.isLocked"
              (change)="onRequiredChange(data.data)"
              class="req-toggle"
            ></mat-slide-toggle>
          </div>

          <dxi-column
            [caption]="'COMMON.ORDER' | translate"
            dataField="order"
            alignment="center"
            [allowEditing]="false"
            [allowSorting]="false"
          ></dxi-column>
        </dx-data-grid>
      </div>
    </div>
    <div class="custom-fields-footer">
      <div class="helper-info">
        <span class="bullet-dot">•</span>
        <span class="info-text">
          {{ 'GUEST-FORM-FIELDS.FOOTNOTE-EMAIL-REQUIRED' | translate }}
        </span>
      </div>
      <button class="reset-link-btn" (click)="reset()">
        {{ 'GUEST-FORM-FIELDS.BUTTON-RESET-DEFAULTS' | translate }}
      </button>
    </div>
  </div>
  <div class="col-auto form-preview">
    <div class="live-preview-badge">
      <span class="status-dot"></span>
      <span class="badge-text">
        {{ 'GUEST-FORM-FIELDS.GUEST-POPUP-LIVE-PREVIEW.TITLE' | translate }}
      </span>
    </div>
    <div class="form-preview-container">
      <div class="form-modal-preview-container">
        <div class="form-header">
          <h2>{{ formLabel }}</h2>
          <button class="close-btn">×</button>
        </div>

        <div class="form-preview-body">
          <dx-form 
            #previewForm
            labelMode="floating"
          >
            <ng-container *ngFor="let field of previewFields">
              <dxi-item
                *ngIf="field.visible"
                [dataField]="field.key"
              >
                <dxo-label 
                  [text]="getLabelKey(field.key) | translate"
                ></dxo-label>
                <dxi-validation-rule
                  *ngIf="field.required"
                  type="required"
                  [message]="getRequiredMessageKey(field.key) | translate">
                </dxi-validation-rule>
                <dxi-validation-rule
                  *ngIf="field.key === emailKey"
                  type="email"
                  [message]="'VALIDATIONS.EMAIL-INVALID' | translate"
                ></dxi-validation-rule>
              </dxi-item>
            </ng-container>
          </dx-form>
          <div class="terms">
            <dx-check-box
              [(value)]="isTermsAccepted"
            ></dx-check-box>
            <label class="terms-label" (click)="isTermsAccepted = !isTermsAccepted">
              {{ 'MY-INVITATION.TERMS' | translate }}
              <span class="required">*</span>
            </label>
          </div>
          <div class="form-cta">
            <dx-button
              [text]="'COMMON.BACK' | translate"
              type="default"
            ></dx-button>
            <dx-button
              [disabled]="!isTermsAccepted"
              [text]="'MY-INVITATION.SEND' | translate"
              type="normal"
              (click)="onSendPreview()"
            ></dx-button>
          </div>
        </div>
      </div>
    </div>
    <div class="preview-limitation">
      {{ 'GUEST-FORM-FIELDS.GUEST-POPUP-LIVE-PREVIEW.FOOTNOTE-PREVIEW-LIMITATION' | translate }}
    </div>
  </div>
</div>